import type { Resource } from '../../';
export const general_errors_tryNewSearch: Resource = {"default":"Try a new search"};
